import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'sm-quick-help',
    templateUrl: './quick-help.component.html',
    styleUrls: ['./quick-help.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class QuickHelpComponent {

    @Input()
    text = "";
    @Input()
    icon = "fas fa-question-circle";
    displayHint = false;

}
